import { createContext } from 'react';

export const DefaultEventContext = {
  registerEvent: (eventName: string, callback: (payload: any) => void) => {
    register[eventName] = register[eventName] || {};
    identifier++;
    register[eventName][identifier] = callback;
    return identifier;
  },
  fireEvent: (eventName: string, payload: any) => {
    Object.values(register[eventName] || {}).forEach((callback) => {
      callback(payload);
    });
  },
  unRegisterEvent: (eventName, identifier) => {
    register[eventName] = register[eventName] || {};
    register[eventName][identifier] = () => {};
  },
};

const register: {
  [k: string]: {
    [k: string]: (payload: any) => void;
  };
} = {};
let identifier = 0;
const EventContext = createContext(DefaultEventContext);

export default EventContext;
